import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Header from './Headers';
import ReactGA from 'react-ga';
import Footer from '../footer';
import {Helmet} from "react-helmet";
import config from 'config'


@inject('store')
@observer
class Product extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ProductsVal: [],
            product_id: [],

        }
    }

    navigateOnId() {
        let splitId = window.location.href;
        let id = splitId.split('#')

        if (id[1]) {
            const violation = document.getElementById(id[1]);
            window.scrollTo({
                top: violation ? violation.offsetTop : '',
                behavior: "smooth"
            });
        }
    }


    productDetails = () => {
        fetch(`${config.REV_URL}/getallproduct`)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                this.setState({
                    ProductsVal: response.data,
                    product_id: response.data.map(a => a._id),
                })
                this.navigateOnId();

            }).catch((err) => {
            console.log(err)
            throw err
        })
    }


    componentDidMount() {
        this.initializeReactGA();
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
        this.productDetails()

    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/product');
    }

    render() {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <meta name="title" content="Electric Three Wheeler and Two wheeler loan"/>
                    <meta name="description"
                          content="Revfin offers Electric Vehicle loans to independent electric vehicle drivers."/>
                    <meta name="keywords" content="Electric Vehicle loan"/>

                </Helmet>
                <Header
                    product_id={this.state.product_id}
                />
                <section className="pdtb-20">
                    <div className="container">

                        <section className="breadcrumbs">
                            <div className="container">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h2>Products</h2>
                                    <ol>
                                        <li><a href="/">Home</a></li>
                                        <li>Products</li>
                                    </ol>
                                </div>
                            </div>
                        </section>

                        {this.state.ProductsVal.map((items, index) => {
                            if (items.product_name == "Electric Three Wheeler loan" || items.product_name == "Electric Two Wheeler Loan" || items.product_name == "Rev Loan" || items.product_name == "EV Ancillary Loan") {
                                return (
                                    <section className="pdtb-20" id={items._id} key={index}>
                                        <div className="container">
                                            <div className="row mgt-5">
                                                <section style={{
                                                    position: 'relative',
                                                    width: '100%',
                                                    marginTop: '60px'
                                                }}>
                                                </section>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <h2 className="fz-25 color_main bold notflor" key={items} style={{

                                                        marginBottom: '30px'
                                                    }}>
                                                        {items.product_name}
                                                    </h2>
                                                    <p>
                                                        {items.description}
                                                    </p>
                                                    <p className=" text-uppercase fz-15">
                                                        <b>Product Purpose</b>
                                                    </p>
                                                    <p>
                                                        {items.productPurpose}
                                                    </p>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                                    <table className="table table-bordered">
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                                <table width="100%">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan="2"
                                                                            style={{'background': '#f1f1f1'}}>
                                                                            <b>Product details</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Loan Amount</td>
                                                                        <td>{items.productdetail.loanamount}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Loan Term</td>
                                                                        <td>{items.productdetail.loanterm} </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Interest Rate</td>
                                                                        <td>{items.productdetail.interestRate}</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        {items.mandatoryrequir ? (
                                                            <tr>
                                                                <td colSpan="2" style={{'padding': '0px'}}>
                                                                    <table width="100%">
                                                                        <tbody>
                                                                        <tr>
                                                                            <td colSpan="2"
                                                                                style={{'background': '#f1f1f1'}}><b>Mandatory
                                                                                requirements </b></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Vehicle Documents</td>
                                                                            <td>{items.mandatoryrequir.vechiledoc}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Others</td>
                                                                            <td>{items.mandatoryrequir.others}</td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="2" style={{'padding': '0px'}}>
                                                                    <table width="100%">
                                                                        <tbody>
                                                                        <tr>
                                                                            <td colSpan="2"
                                                                                style={{'background': '#f1f1f1'}}><b>Mandatory
                                                                                requirements </b></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Vehicle Documents</td>
                                                                            <td></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Others</td>
                                                                            <td></td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        )}

                                                        <tr>
                                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                                <table width="100%">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan="2"
                                                                            style={{'background': '#f1f1f1'}}><b>Eligibility
                                                                            Criteria</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Customer Age</td>
                                                                        <td>{items.elegibilityCrit.customerage}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Minimum monthly income</td>
                                                                        <td>{items.elegibilityCrit.minmonthincome}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Documents Required</td>
                                                                        <td>{items.elegibilityCrit.docrequired}</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                                <table width="100%">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan="2"
                                                                            style={{'background': '#f1f1f1'}}><b>Applicable
                                                                            Charges</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Processing fee/origination charges</td>
                                                                        <td>{items.applicableChg.processing_fee}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Foreclosure charges</td>
                                                                        <td>{items.applicableChg.foreclousechg}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Additional interest on late payment of EMI
                                                                        </td>
                                                                        <td>{items.applicableChg.additionalint}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Per EMI bounce charge</td>
                                                                        <td>{items.applicableChg.peremibouncechg}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Legal/incidental charges</td>
                                                                        <td>{items.applicableChg.legalchg}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Loan cancellation charges</td>
                                                                        <td>{items.applicableChg.loancanclechg}</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>

                                                        </tbody>
                                                    </table>

                                                </div>

                                            </div>
                                        </div>

                                    </section>
                                )
                            } else if (items.product_name == "Electric Two Wheeler Lease") {
                                return (

                                    <section className="pdtb-20" id={items._id} key={index}>
                                        <div className="container">
                                            <div className="row mgt-5">
                                                <section style={{
                                                    position: 'relative',
                                                    width: '100%',
                                                    marginTop: '60px'
                                                }}>
                                                </section>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <h2 className="fz-25 color_main bold notflor" key={items} style={{

                                                        marginBottom: '30px'
                                                    }}>
                                                        {items.product_name}
                                                    </h2>
                                                    <p>
                                                        {items.description}
                                                    </p>
                                                    <p className=" text-uppercase fz-15">
                                                        <b>Product Purpose</b>
                                                    </p>
                                                    <p>
                                                        {items.productPurpose}
                                                    </p>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                                    <table className="table table-bordered">
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                                <table width="100%">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan="2"
                                                                            style={{'background': '#f1f1f1'}}>
                                                                            <b>Product details</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Monthly Lease Rental</td>
                                                                        <td>{items.productdetail.leaseamount}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Lease Term</td>
                                                                        <td>{items.productdetail.leaseterm} </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                                <table width="100%">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan="2"
                                                                            style={{'background': '#f1f1f1'}}><b>Eligibility
                                                                            Criteria</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Customer Age</td>
                                                                        <td>{items.elegibilityCrit.customerage}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Minimum monthly income</td>
                                                                        <td>{items.elegibilityCrit.minmonthincome}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Aggregator aggrement</td>
                                                                        <td>{items.elegibilityCrit.aggregatoragreement}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Documents Required</td>
                                                                        <td>{items.elegibilityCrit.docrequired}</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan="2" style={{'padding': '0px'}}>
                                                                <table width="100%">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan="2"
                                                                            style={{'background': '#f1f1f1'}}><b>Applicable
                                                                            Charges</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Processing fee/origination charges</td>
                                                                        <td>{items.applicableChg.processing_fee}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Late payment fees</td>
                                                                        <td>{items.applicableChg.latepaymentfees}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Legal/incidental charges</td>
                                                                        <td>{items.applicableChg.legalchg}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>End of lease buy-back price</td>
                                                                        <td>{items.applicableChg.endOfLeaseBuyBack}</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>

                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>

                                    </section>


                                )
                            }
                        })}


                    </div>
                </section>
                <Footer
                />
            </div>
        )
    }
}


export default Product



// WEBPACK FOOTER //
// ./src/components/product.js